import { trackEvent, EVENTS } from 'common/utils/tracker'
import getBrowserInfo from 'common/utils/get-browser-info'

function captureSessionInfo({
  page,
  provider,
  issuer,
  correlationId
}: {
  page: string
  provider: string
  issuer: string
  correlationId: string
}) {
  trackEvent(EVENTS.SESSION_INFO, {
    page,
    provider,
    issuer,
    correlationId,
    ...getBrowserInfo()
  })
}

export default captureSessionInfo
